module.exports = __webpack_public_path__ + "img/602925430cd543049bf7318a95e656e5.faffd0c3.jpg";